import type {
  GetInvoiceInformationResponse,
  UpdateInvoiceInformationBody,
} from "@nlc/shared-types";
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { subscriptionKeys } from "@/hooks/queryKeys";

const MOCK_INVOICE_INFORMATION: GetInvoiceInformationResponse = {
  address: "221B Baker Street, London",
  billToEmail: "billing@secretagent.com",
  companyName: "Secret Agent Inc.",
  fullName: "Jane Cooper",
  notes: "VAT ID: DE123456789\nPO number: 647647",
  secondaryEmail: "finance@secretagent.com",
};

export function useInvoiceInformation(
  projectId: number,
): UseQueryResult<GetInvoiceInformationResponse> {
  return useQuery<GetInvoiceInformationResponse>({
    queryFn: () => MOCK_INVOICE_INFORMATION,
    queryKey: subscriptionKeys.invoiceInformation(projectId),
    staleTime: Infinity,
  });
}

export function useUpdateInvoiceInformation(
  projectId: number,
): UseMutationResult<
  UpdateInvoiceInformationBody,
  Error,
  UpdateInvoiceInformationBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (changes: UpdateInvoiceInformationBody) => changes,
    onSuccess: (changes) => {
      queryClient.setQueryData<GetInvoiceInformationResponse>(
        subscriptionKeys.invoiceInformation(projectId),
        (current) => current && { ...current, ...changes },
      );

      toast.add({
        description: "Changes will apply to future invoices only.",
        timeout: 3000,
        title: "Invoice information saved",
        type: "success",
      });
    },
  });
}
